import { render, staticRenderFns } from "./motCanTendero.vue?vue&type=template&id=53fac3c5&scoped=true&"
import script from "./motCanTendero.vue?vue&type=script&lang=js&"
export * from "./motCanTendero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fac3c5",
  null
  
)

export default component.exports